import React, {Component} from 'react';
import moment from 'moment';

import StoreS3 from './../util/StoreS3.jsx';
import Common from './../util/Common.jsx';
import {SectionTitle, ContentWrapper, GenericButton} from './../util/Styles.jsx'
import InputTextBar from './../util/InputTextBar.jsx'

import Workset from "./catalog/Workset.jsx"

export class EditWebsite extends Component {

    static propTypes = {}

    state = {
        adding_div: false,
        div_files: []
    };

    componentDidMount() {
        this.get_divs();
    }

    async get_divs() {
        const div_files = await StoreS3.list_files('website');
        this.setState({div_files: div_files.Contents});
    }

    add_div() {
        this.setState({adding_div: true})
    }

    confirm_add_div = (new_name) => {
        const slug_form = Common.slugify(new_name);
        if (!slug_form.length) {
            return;
        }
        const path = "website/" + slug_form + ".json";
        const data = {
            title: new_name,
            slug: slug_form,
            path: path,
            type: "div",
            value: "",
            created: moment().format(),
        }
        StoreS3.put_file(path, JSON.stringify(data, undefined, 2));
        const that = this;
        setTimeout(function () {
            that.get_divs();
            that.setState({
                adding_div: false,
            });
        }, 500);
    }

    cancel_add_div = () => {
        this.setState({adding_div: false});
    }

    render() {
        const page_title = <SectionTitle>Web Design</SectionTitle>
        const add_div = <GenericButton onClick={e => this.add_div()}>add...</GenericButton>;
        const add_div_name = !this.state.adding_div ? '' :
            <InputTextBar
                callback_ok={this.confirm_add_div}
                callback_cancel={this.cancel_add_div}/>
        console.log(this.state.div_files);
        const divs = this.state.div_files.sort((a, b) => a.Key.localeCompare(b.Key))
            .map((div_file, index) =>
                <Workset
                    key={"div_" + index}
                    workset_file={div_file}/>);
        return <ContentWrapper>
            {page_title}
            {add_div}{add_div_name}
            {divs}
        </ContentWrapper>
    }
}

export default EditWebsite;

